import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDuration'
})
export class FormatDurationPipe implements PipeTransform {

  transform(value: string | null): string {
    if (!value) return '';
    const parts = value.split(':').map(part => parseInt(part, 10));
    const [hours, minutes, seconds] = parts;
    const mm = (minutes ?? 0).toString().padStart(2, '0');
    const ss = (seconds ?? 0).toString().padStart(2, '0');
    if (hours > 0) return `${hours.toString().padStart(2, '0')}:${mm}:${ss}`;
    return `${mm}:${ss}`;
  }
  
}
